// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cNcCxM {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 0;
  pointer-events: none;
}

.eLCTXu {
  position: fixed;
  left: auto;
  z-index: 1000;
  width: fit-content;
  min-width: 350px;
  max-width: calc(100vw - var(--spacing-3) * 2);
}

.U4Otcz {
  width: 100%;
  min-width: initial !important;
  margin: 0 !important;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);
  border-radius: var(--radius-s, 4px);
}

.U4Otcz [data-testid='alert-text'] {
  min-width: 0;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AnchoredAlert/AnchoredAlert.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;EACpB,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":[".marker {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 0;\n  pointer-events: none;\n}\n\n.anchor {\n  position: fixed;\n  left: auto;\n  z-index: 1000;\n  width: fit-content;\n  min-width: 350px;\n  max-width: calc(100vw - var(--spacing-3) * 2);\n}\n\n.alert {\n  width: 100%;\n  min-width: initial !important;\n  margin: 0 !important;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16);\n  border-radius: var(--radius-s, 4px);\n}\n\n.alert [data-testid='alert-text'] {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marker": `cNcCxM`,
	"anchor": `eLCTXu`,
	"alert": `U4Otcz`
};
module.exports = ___CSS_LOADER_EXPORT___;
